import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";

/**
 * https://github.com/jaredpalmer/formik/blob/next/src/connect.tsx
 * License: https://github.com/jaredpalmer/formik/blob/next/LICENSE
 */
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import createContext from 'create-react-context';

var _createContext = createContext({}),
    FormProvider = _createContext.Provider,
    FormConsumer = _createContext.Consumer;
/**
 * Connect any component to Form context, and inject as a prop called `form`;
 * @param Comp React Component
 */


export { FormProvider, FormConsumer };
export function connect(Comp) {
  var C = function C(props) {
    return /*#__PURE__*/React.createElement(FormConsumer, null, function (formProps) {
      return /*#__PURE__*/React.createElement(Comp, _Object$assign({}, props, {
        form: formProps
      }));
    });
  };
  /* istanbul ignore next */


  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
  // For example, <Field.WrappedComponent /> gets us <FieldInner/>

  C.WrappedComponent = Comp;
  C.displayName = "FormConnect(".concat(componentDisplayName, ")");
  return hoistNonReactStatics(C, Comp // cast type to ComponentClass (even if SFC)
  );
}